import React from 'react';
import { Card, Row, Col, Space, Typography } from 'antd';

const { Text } = Typography;

const EntryCard = ({ children, style = {} }) => {
    return (
        <Card 
            size="small"
            style={{ 
                marginBottom: 8,
                boxShadow: '0 1px 4px rgba(0, 0, 0, 0.05)',
                transition: 'all 0.3s',
                borderRadius: 4,
                width: '100%',
                ...style
            }}
            styles={{ body: { padding: '12px' } }}
        >
            <Row>
                <Col span={24}>
                    <Space direction="vertical" style={{ width: '100%' }}>
                        {children}
                    </Space>
                </Col>
            </Row>
        </Card>
    );
};

export default EntryCard; 